/**
 * BillingAccountAPI
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PeriodInterval } from './periodInterval';
import { ReadClientDto } from './readClientDto';
import { ReadResourceDto } from './readResourceDto';

export interface TotalRevenueCardDto { 
    merchant?: string;
    periodInterval?: PeriodInterval;
    totalRevenue?: number;
    clients?: Array<ReadClientDto>;
    resources?: Array<ReadResourceDto>;
}